import { Batch } from '@models/batch.model';

export class Slot {
    public id: number;
    public name: string;
    public batches: Batch[];
    public hasTools: boolean;
    public label: string;

    constructor(slot: any = {}) {
        this.id = slot.id || 0;
        this.name = slot.name || '';
        this.label = slot.label;
        this.batches = slot.batches ? slot.batches.map(batch => new Batch(batch)) : [];
        this.hasTools = slot.hasTools;
    }

    get type() {
        return 'slot';
    }
}
